import { StarsButton, Translation } from '@ps/web-shared-components';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import useSearchParams from '@swf/core/hooks/useSearchParams';
import type { LoginPayload } from '@swf/core/models/auth/login';
import type { Dispatch } from '@swf/core/store';

import {
  TXTCLI_Cancel,
  TXTWCL_Do_you_wish_to_proceedX,
  TXTWCL_If_you_decide_to_transfer_your_ELL,
  TXTWCL_Transfer_Session_to_this_Devic_ELL,
  TXTWCL_You_have_requested_to_login_to_ELL
} from './SessionTransfer.messages.json';

const SessionTransfer: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const searchParams = useSearchParams<LoginPayload>();

  const { auth, modal } = useDispatch<Dispatch>();

  const handleSessionTransfer = () => {
    setLoading(true);
    auth.login({ ...searchParams, sessionTransfer: true });
  };

  return (
    <>
      <p>
        <Translation {...TXTWCL_You_have_requested_to_login_to_ELL} />{' '}
        <Translation {...TXTWCL_If_you_decide_to_transfer_your_ELL} />
      </p>
      <Translation {...TXTWCL_Do_you_wish_to_proceedX} />
      <ButtonGroup>
        <StarsButton
          block
          loading={loading}
          onClick={handleSessionTransfer}
          translation={TXTWCL_Transfer_Session_to_this_Devic_ELL}
        />
        <StarsButton
          block
          variant="secondary"
          translation={TXTCLI_Cancel}
          onClick={() => modal.close('/auth/session-transfer')}
        />
      </ButtonGroup>
    </>
  );
};

export default SessionTransfer;
